
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.541 4.72a2.548 2.548 0 00-1.184 2.155v8.25a4.124 4.124 0 004.125 4.125h8.25a2.55 2.55 0 002.156-1.185l-.096.005-.096.002H6.482a2.947 2.947 0 01-2.946-2.947V4.911c0-.064.001-.128.005-.19zm7.905 6.396l-.073.062-5.836 5.73c.402.248.866.379 1.338.378h9.821c.491 0 .95-.139 1.338-.378l-5.835-5.73-.066-.055a.589.589 0 00-.607-.054l-.08.047zM6.875 2.357a2.554 2.554 0 00-2.554 2.554v9.821c0 .493.14.953.382 1.344l5.844-5.74.101-.091a1.768 1.768 0 012.27-.005l.107.097 5.844 5.738c.25-.403.382-.868.381-1.343V4.911a2.554 2.554 0 00-2.554-2.554H6.875zm1.768 3.34a.982.982 0 11.055 1.963.982.982 0 01-.055-1.964z"}})])
          )
        }
      }
    